import { isBrowser } from '@backmarket/utils/env/isBrowser'

declare global {
  interface Window {
    ebRecoIds?: string[]
  }
}

export const getUserRecommendationId = () => {
  if (!isBrowser()) {
    return null
  }

  return localStorage?.getItem('attraqtsessionid')
}

export const setRecommendationDebugExtension = (id: string | null = null) => {
  if (!isBrowser()) {
    return
  }
  if (!id) {
    return
  }
  window.ebRecoIds = [...new Set(window.ebRecoIds).add(id)]
}
